import { useTheme } from '@emotion/react';

import { type MOOD_STATES, MOODS } from '../constants';
import * as styles from '../MoodBox.styles';
import { faceIllustrationColorMap } from '../MoodBox.styles';

type NeutralMoodProps = {
  state: MOOD_STATES;
};

export const NeutralMood = ({ state }: NeutralMoodProps) => {
  const theme = useTheme();

  const color = faceIllustrationColorMap(MOODS.NEUTRAL, state, theme);

  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      css={styles.neutralMood}
    >
      <path
        d="M1.79998 0.899902C2.46272 0.899902 2.99998 1.43716 2.99998 2.0999V2.6999C2.99998 3.36264 2.46272 3.8999 1.79998 3.8999C1.13723 3.8999 0.599976 3.36264 0.599976 2.6999V2.0999C0.599976 1.43716 1.13723 0.899902 1.79998 0.899902Z"
        fill={color}
      />
      <path
        d="M10.2 0.899902C10.8627 0.899902 11.4 1.43716 11.4 2.0999V2.6999C11.4 3.36264 10.8627 3.8999 10.2 3.8999C9.53723 3.8999 8.99998 3.36264 8.99998 2.6999V2.0999C8.99998 1.43716 9.53723 0.899902 10.2 0.899902Z"
        fill={color}
      />
      <path
        d="M0.599976 9.8999C0.599976 9.23716 1.13723 8.6999 1.79998 8.6999H10.2C10.8627 8.6999 11.4 9.23716 11.4 9.8999C11.4 10.5626 10.8627 11.0999 10.2 11.0999H1.79998C1.13723 11.0999 0.599976 10.5626 0.599976 9.8999Z"
        fill={color}
      />
    </svg>
  );
};
